// extracted by mini-css-extract-plugin
module.exports = {"container":"Pages_container__1F354","pages":"Pages_pages__T3av2","page":"Pages_page__Dtoi0","paginationWrapper":"Pages_paginationWrapper__bRghW","loading":"Pages_loading__p1Vzj"};